import React from "react";

const PAGE_SIZES = [20, 50, 100];

/** Page numbers to show around the current page: 1 … 4 5 [6] 7 8 … 20 */
const pageWindow = (page, totalPages, size = 5) => {
  let start = Math.max(page - Math.floor(size / 2), 1);
  const end = Math.min(start + size - 1, totalPages);
  start = Math.max(end - size + 1, 1);
  const pages = [];
  for (let i = start; i <= end; i++) pages.push(i);
  return pages;
};

/**
 * Server-side pagination footer.
 * Uses the shared .pagination-container / .page-link-custom styles.
 */
const Pagination = ({
  page,
  limit,
  total,
  onPageChange,
  onLimitChange,
  pageSizes = PAGE_SIZES,
}) => {
  const totalPages = Math.max(1, Math.ceil((total || 0) / (limit || 1)));
  const pages = pageWindow(page, totalPages);

  return (
    <div className="pagination-container d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
      <div className="d-flex align-items-center gap-2 fs-075 text-slate-500">
        <span>Show</span>
        <select
          className="items-select"
          value={limit}
          onChange={(e) => onLimitChange(Number(e.target.value))}
          aria-label="Rows per page"
        >
          {pageSizes.map((v) => (
            <option key={v} value={v}>
              {v}
            </option>
          ))}
        </select>
        <span>
          of <strong>{(total || 0).toLocaleString()}</strong> entries
        </span>
      </div>

      <nav className="d-flex align-items-center" aria-label="Pagination">
        <button
          type="button"
          className={`page-link-custom ${page <= 1 ? "disabled" : ""}`}
          onClick={() => page > 1 && onPageChange(page - 1)}
          disabled={page <= 1}
          aria-label="Previous page"
        >
          <i className="bi bi-chevron-left"></i>
        </button>

        {pages[0] > 1 && (
          <>
            <button
              type="button"
              className="page-link-custom"
              onClick={() => onPageChange(1)}
            >
              1
            </button>
            {pages[0] > 2 && <span className="mx-1 text-muted">…</span>}
          </>
        )}

        {pages.map((p) => (
          <button
            key={p}
            type="button"
            className={`page-link-custom ${p === page ? "active" : ""}`}
            onClick={() => onPageChange(p)}
            aria-current={p === page ? "page" : undefined}
          >
            {p}
          </button>
        ))}

        {pages[pages.length - 1] < totalPages && (
          <>
            {pages[pages.length - 1] < totalPages - 1 && (
              <span className="mx-1 text-muted">…</span>
            )}
            <button
              type="button"
              className="page-link-custom"
              onClick={() => onPageChange(totalPages)}
            >
              {totalPages}
            </button>
          </>
        )}

        <button
          type="button"
          className={`page-link-custom ${page >= totalPages ? "disabled" : ""}`}
          onClick={() => page < totalPages && onPageChange(page + 1)}
          disabled={page >= totalPages}
          aria-label="Next page"
        >
          <i className="bi bi-chevron-right"></i>
        </button>
      </nav>
    </div>
  );
};

export default Pagination;
